(() => {
  'use strict';

  const EXPIRY_HOURS = 8;
  const STAMP_KEY = 'ab.cart.seen';

  const read = () => {
    try {
      return Number(localStorage.getItem(STAMP_KEY)) || 0;
    } catch {
      return 0;
    }
  };

  const write = (value) => {
    try {
      if (value) {
        localStorage.setItem(STAMP_KEY, String(value));
      } else {
        localStorage.removeItem(STAMP_KEY);
      }
    } catch {
      /* private browsing */
    }
  };

  const check = async () => {
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

      if (!cart.item_count) {
        write(0);
        return;
      }

      const seen = read();

      if (!seen) {
        write(Date.now());
        return;
      }

      if (Date.now() - seen > EXPIRY_HOURS * 3600000) {
        await fetch('/cart/clear.js', { method: 'POST' });
        write(0);

        if (window.location.pathname.replace(/\/$/, '').endsWith('/cart')) {
          window.location.reload();
        }

        return;
      }
    } catch (error) {
      console.warn('[ab-cart-expiry]', error);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
})();